import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { MagentoLinkedService } from 'app/model/linkedservice/magento.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MagentoLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                accessToken: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class MagentoLinkedServiceAdapter extends LinkedServiceAdapter<MagentoLinkedService> {
    protected modelConstructor(): new () => MagentoLinkedService {
        return MagentoLinkedService;
    }

    protected model(): IModel {
        return MagentoLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: MagentoLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.MagentoLinkedService;
        properties.type = Metamodel.modelFor(MagentoLinkedService).name;

        properties.typeProperties = {
            host: linkedService.host,
            accessToken: passwordOrAKVtoSecretBase(linkedService.accessToken, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: MagentoLinkedService): Promise<MagentoLinkedService> {
        const properties = linkedServiceResource.properties as Model.MagentoLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.MagentoLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.host = typeProperties.host;
        linkedService.accessToken = secretBaseToPasswordOrAKV(typeProperties.accessToken, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
